module.exports = __webpack_public_path__ + "media/service_features/h_k-c8dff8cd.png";